import { PRODUCT_SHORT, countryName } from "../lib/constants";
import { HINT } from "./HowWeCount";
import { PartnerBadge } from "./PartnerBadge";

const shortDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
};

export const LatestClients = ({ latest, highlights, title = "Latest new venues", emptyText = "No new venues in this view yet" }) => {
  const rows = (latest || []).slice(0, 12);
  return (
    <section className="panel flex-1 flex flex-col min-h-0 overflow-hidden fade-up" data-testid="latest-clients-list">
      <div className="px-4 pt-3 tv:px-[17px] tv:pt-[14px]">
        <span className="eyebrow" title={HINT.latest}>{title}</span>
      </div>
      <div className="flex-1 min-h-0 grid grid-flow-row tv:grid-flow-col tv:grid-rows-[repeat(12,minmax(0,1fr))] tv:grid-rows-[repeat(6,minmax(0,1fr))] grid-cols-1 tv:grid-cols-2 gap-x-4 tv:gap-x-[17px] px-4 pb-3 tv:px-[17px] tv:pb-[13px]">
        {rows.length === 0 && <div className="text-slate-400 text-sm self-center py-6 tv:py-0" data-testid="latest-clients-empty">{emptyText}</div>}
        {rows.map((c) => (
          <div
            key={c.id}
            data-testid={`latest-client-item-${c.id}`}
            data-partner={c.partner && !c.upsell ? "true" : undefined}
            data-upsell={c.upsell ? "true" : undefined}
            className={`min-w-0 min-h-0 flex flex-col justify-center border-l-2 pl-2.5 tv:pl-[12px] my-1 tv:my-0.5 py-0.5 tv:py-0 ${highlights?.has(c.id) ? "row-flash " : ""}${c.upsell ? "border-sky-400 bg-sky-50/60 rounded-r-md pr-1.5" : c.partner ? "border-amber-400 bg-amber-50/70 rounded-r-md pr-1.5" : highlights?.has(c.id) ? "border-brand" : "border-brand/60"}`}
          >
            <div className="flex items-center gap-1.5 min-w-0">
              <div
                className="font-semibold text-sm tv:text-[17px] leading-tight truncate text-ink"
                title={[c.upsell && c.deal_name ? `Deal: ${c.deal_name}` : null, c.merchant && c.merchant !== c.name ? `Merchant: ${c.merchant}` : null, c.deals > 1 ? `${c.deals} deals` : null].filter(Boolean).join(" · ") || undefined}
              >
                {c.name || "(unnamed deal)"}
              </div>
              {c.upsell ? (
                <span data-testid={`latest-client-upsell-${c.id}`} title="Product sold to a venue that was already a client before the cutoff – counted in products, not as a new venue" className="rounded-full bg-sky-100 text-sky-800 px-1.5 text-[9px] tv:text-[11px] font-bold uppercase tracking-wide shrink-0">upsell</span>
              ) : (
                <PartnerBadge label={c.partner} testId={`latest-client-partner-${c.id}`} />
              )}
            </div>
            <div className="text-[11px] tv:text-[13px] text-slate-500 truncate leading-tight mt-0.5">
              {c.merchant && c.merchant !== c.name ? <span data-testid="latest-client-merchant">{c.merchant} · </span> : null}
              <span title={c.country}>{c.country === "ZZ" ? "No country" : countryName(c.country)}</span>
              {c.products?.length ? <span> · {c.products.map((p) => PRODUCT_SHORT[p] || p).join(" + ")}</span> : null}
              <span className="num"> · {shortDate(c.won_at)}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
